(function ($) {
    $(() => {

        
        //MENU TRANSFORM ON SCROLLING
        const nav = $('#menu');
        var lastScrollTop = 0;
       
        $(window).scroll(function () {
            let active_menu = false

            if($('.front-page').length !== 0) {
                if ($(window).scrollTop() > 50) {
                    nav.addClass('scrolled');
                } else {
                    $('.js-open-dropdown').each(function() {
                        if($(this).hasClass('active')){ 
                            active_menu = true;
                        }
                    });

                    if(!active_menu) {
                        nav.removeClass('scrolled');
                    }
                }
            } else {
                if ($(window).scrollTop() > 50) {
                    nav.addClass('page-scrolled');
                } else {
                    nav.removeClass('page-scrolled');
                }

                 // DETECT SCROLL DIRECTION
                //
                
                var st = $(this).scrollTop();
                if (st <= lastScrollTop){
                    nav.addClass('is-showed');
                  
                } else {
                    nav.removeClass('is-showed');
                 
                }
                lastScrollTop = st;
            }

            

        });

        //megamenu tabs working
        $('.js-tab a').on('mouseenter', function (e) {
            e.preventDefault();

            const id = $(this).data('page')

            $(this).parent().parent().find('.js-tab').removeClass('active');
            $(this).parent().addClass('active');

            $(this).parent().parent().parent().parent().find('.js-mega-row').addClass('hide');

            $(`#page-${id}`).removeClass('hide');
        });


        $('.js-open-dropdown').on('mouseenter', function(e) {
            e.preventDefault();
            e.stopPropagation();
            const currentDropdown = $(this).find('.dropdown-menu');
            const current = $(this);
            
            $('.js-megamenu-opener').removeClass('opened');
            $('.js-megamenu').removeClass('open');
            $('body').removeClass('openMega');

            $('.js-open-dropdown').each(function() {
                
                if($(this).is(current)) {
                    if($(this).hasClass('current-menu-ancestor')) {
                        return;
                    }
                    $(this).addClass('active');
                   
                } else {
                    if($(this).hasClass('current-menu-ancestor')) {
                        $(this).find('.dropdown-menu').addClass('removeActive');
                    }
                    $(this).removeClass('active');
                }
            });

            $('.dropdown-menu').each(function() {
                
                if($(this).is(currentDropdown)) {
                    $(this).addClass('more-zindex');
                } else {
                    $(this).removeClass('more-zindex');
                }
            });

            if ($(window).scrollTop() > 50) {
                
            } else {
                if(!$('.navbar').hasClass('scrolled')) {
                    $('.navbar').addClass('scrolled');
                }
            }
        });
        //open-megamenu 

        $('.js-megamenu-opener').on('mouseenter', function(e) {
            e.preventDefault();
            e.stopPropagation();

            
            $('.js-megamenu-opener').removeClass('opened');
            $(this).addClass('opened');

            const megamenuId = $(this).data('opener');

            $('.js-megamenu').removeClass('open');
            $(`#${megamenuId}`).addClass('open');

            $('body').addClass('openMega');
        });

        //close megamenu and close dropdown

        $('.js-megamenu').on('mouseleave', function() {
            $('.js-megamenu-opener').removeClass('opened');
            $(this).removeClass('open');
            $('body').removeClass('openMega');
            $('.current-menu-ancestor').find('.dropdown-menu').removeClass('removeActive');
           
            $('.js-open-dropdown').each(function() {
                if(!$(this).hasClass('current-menu-ancestor')) {
                    $(this).removeClass('active');
                }
            });

            if ( $('.front-page').length !== 0 && $(window).scrollTop() < 50) {
                $('.navbar').removeClass('scrolled');
            }
        });

        // mouseleave on megamenu, close it if no megamenu is open, and remove activ from dropdown opener

        $('.dropdown-menu').on('mouseleave', function() {

            if($(this).parent().hasClass('current-menu-ancestor')) {
                return;
            }

            if(!$('.js-megamenu').hasClass('open')) {
                $('.dropdown-menu').parent().removeClass('active');
               
                if ( $('.front-page').length !== 0 && $(window).scrollTop() < 50) {
                // $('.navbar').removeClass('scrolled');
                }
            }

            
            $('.dropdown-menu').each(function() {
                if($(this).parent().hasClass('current-menu-ancestor')) {
                    $(this).parent().addClass('active');
                }
            });

        });

        //if no meagemnu opener
        $('.dropdown-menu a').on('mouseenter', function() {
            if(!$(this).hasClass('js-megamenu-opener')) {
                $('.js-megamenu').removeClass('open');
                $('body').removeClass('openMega');
                $('.js-megamenu-opener').removeClass('opened');
            }
        });


        //js dropdown open

        $('.js-open-dropdown').on('mouseleave', function() {
            if(!$('.js-megamenu').hasClass('open')) {
                $('.current-menu-ancestor').find('.dropdown-menu').removeClass('removeActive');
            }
        });

     

        $('.dropdown-menu').on('click', function(e) {
            e.stopPropagation();
        })


        for(let i = 2; i < 5; i++){

            $(`#menu-footer_${i} .menu-item:first-child a`).on('click', function(e){
              var width = $(window).width();
            
              if(width < 768){
      
                e.preventDefault();
      
                const items =  $(`#menu-footer_${i}`).find('.nav-link');
      
                items.each(function( index ) {
      
                  if(index > 0){
                    $( this ).toggleClass('show');
                  }
            
                });
              }    
            });
          }

          $('.js-shop-dropdown').hover(
            function() {
                $(this)
                    .find('.dropdown-content')
                    .removeClass('closed');
            },
            function() {
                const dropdown = $(this).find('.dropdown-content');

                setTimeout(() => {
                    if (!dropdown.hasClass('opened')) {
                        dropdown.addClass('closed');
                    }
                }, 200);
            }
        );

        $('.dropdown-content').hover(
            function() {
                $(this).addClass('opened');
            },
            function() {
                $(this).removeClass('opened');
            }
        );

    });
})(jQuery);
